var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.94,
    y: 0.94,
    width: 92.12,
    height: 92.12,
    rx: 46.06,
    fill: "#FFE8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.94,
    y: 0.94,
    width: 92.12,
    height: 92.12,
    rx: 46.06,
    stroke: "#FF5858",
    strokeWidth: 1.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.858 50.683C29.5912 51.7358 30.8884 52.3374 32.3736 52.3374H40.0816C40.5892 52.3374 41.0592 52.5442 41.3788 52.9202C41.7172 53.2962 41.8488 53.8226 41.7736 54.3678L40.8148 60.5342C40.4012 62.3766 41.6232 64.4446 43.4656 65.065C45.1764 65.7042 47.188 64.8394 47.9964 63.6174L55.9112 51.8298L56.1368 51.4538V34.8346L55.8548 34.5526L49.8952 29.9466C49.1056 29.157 47.3196 28.7246 46.06 28.7246H38.728C36.2088 28.7246 33.6708 30.6234 33.1068 32.9358L28.482 47.017C28.012 48.3518 28.1436 49.6678 28.858 50.683Z",
    fill: "#C72929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7654 57.5468H61.7018C64.6158 57.5468 65.8002 56.4188 65.8002 53.6364V34.7424C65.8002 31.96 64.6158 30.832 61.7018 30.832H59.7654C56.8514 30.832 55.667 31.96 55.667 34.7424V53.6552C55.667 56.4188 56.8514 57.5468 59.7654 57.5468Z",
    fill: "#C72929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDislike);
export default __webpack_public_path__ + "static/media/red-dislike.4016f193a41704cbcd6d2a5265fed3ca.svg";
export { ForwardRef as ReactComponent };